// extracted by mini-css-extract-plugin
module.exports = {"input":"NotificationsPage_input__JQQ1S","select":"NotificationsPage_select__QddBq","tabs":"NotificationsPage_tabs__3YbdM"};